module.exports = __webpack_public_path__ + "static/media/Boxplot.4b3563ed.svg";